import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ApolloProvider } from '@apollo/client'
import { Dimmer, Loader } from 'semantic-ui-react'
import { useRouter } from 'next/router'
import _ from 'lodash'

import { Menu } from 'components/Common'
import Footer from 'components/Footer'
import closeChatbot from 'helpers/closeChatbot'
import { ACCOUNT_HOLDER_COLOR } from 'helpers/account/profileBadgeUtils'

import { useTheme } from 'contexts/ThemeProvider'

import { getGlobalLoadingFlag } from 'stores/Global/Select'
import { useApolloClient } from '@enlyt/base'
import { user as userSelector } from '@enlyt/stores/Auth/Select'
import {
  getAccountDetails,
  getAccountDetailsLoading
} from 'stores/Account/Select'
import AccountActions from 'stores/Account/Actions'

import localization from './localization'
import withLocalization from 'helpers/localizationUtils'

const PageLayout = ({ children, t, styles }) => {
  const { isDark } = useTheme()
  const { apolloClient } = useApolloClient()
  const dispatch = useDispatch()

  const MENU_ITEMS = [
    {
      href: '/',
      icon: 'home',
      label: t('home')
    },
    {
      href: '/myHealth',
      icon: 'heart',
      label: t('myHealth')
    },
    {
      href: '/appointments',
      icon: 'stethoscope',
      label: t('appointments')
    },
    {
      href: '/messages',
      icon: 'messages',
      label: t('messages')
    }
  ]

  const router = useRouter()
  const authenticatedUser = useSelector(userSelector)
  const account = useSelector(getAccountDetails)
  const isAccountLoading = useSelector(getAccountDetailsLoading)
  const globalLoadingFlag = useSelector(getGlobalLoadingFlag)

  useEffect(() => {
    if (
      !isAccountLoading &&
      !_.isEmpty(authenticatedUser) &&
      _.isEmpty(account)
    ) {
      dispatch(AccountActions.getAccountDetails())
    }
  }, [account, authenticatedUser, dispatch, isAccountLoading])

  const handleSignOut = useCallback(() => {
    closeChatbot('help-chatbot')
    router.push('/auth/sign-out')
  }, [router])

  const layoutStyles = {
    flex: 1,
    position: 'relative',
    top: -15
  }

  return (
    <ApolloProvider client={apolloClient} connectToDevTools>
      <Dimmer active={globalLoadingFlag} inverted={!isDark} page>
        <Loader size='large' />
      </Dimmer>
      <Menu
        menuItems={MENU_ITEMS}
        notificationCount={8}
        firstname={account?.firstname}
        lastname={account?.lastname}
        badgeBackgroundColor={account ? ACCOUNT_HOLDER_COLOR : null}
        isProfileBadgeLoading={isAccountLoading}
        handleRightAction={handleSignOut}
      />
      <div style={{ ...layoutStyles, ...styles }}>{children}</div>
      <Footer />
    </ApolloProvider>
  )
}

export default withLocalization(PageLayout, localization)
